import { Link } from "react-router-dom";
import logoImage from "../assets/logo.png";

const Logo = ({ size = "default", linkTo = "/" }) => {
  // Responsive sizes - bigger on mobile since new logo has stacked text
  const sizes = {
    small: "h-16 sm:h-14 md:h-16",
    default: "h-28 sm:h-24 md:h-28",
    large: "h-32 sm:h-28 md:h-32",
    hero: "h-40 sm:h-36 md:h-40",
  };

  const heightClass = sizes[size] || sizes.default;

  const LogoContent = () => (
    <img 
      src={logoImage} 
      alt="Advanta Plus - More Fun. Less Money." 
      className={`${heightClass} w-auto object-contain`}
    />
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center hover:opacity-90 transition-opacity">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default Logo;
